@import "../../globals/scss/label";

:host {
  outline: none; // For tabindex
}

.component {
  .header-wrapper {
    // Needed for the thumb that overflows the border with 1px
    overflow: hidden;

    .header {
      position: relative;

      .thumb {
        width: 30px;
        position: absolute;
        right: -1px;
        top: -1px;
        bottom: -1px;

        // Make sure the .thumb doesn't receive focus on click.
        // Instead, "forward" the focus to the component to guarantee the focus border.
        pointer-events: none;

        // Spinner
        display: flex;
        justify-content: center;
        align-items: center;

        > .icon {
          @include arrow($color-int-blue);
          @include arrow--down;
          width: 100%;
          transform-origin: 50% 50%;
        }
      }

      &:hover {
        cursor: pointer;

        .thumb {
          > .icon {
            @include arrow($color-int-blue--active);
          }
        }
      }
    }
  }
}

// Open/opening
.component.open,
.component.opening {
  .header-wrapper {
    box-shadow: 0 0 4px 0 rgba($color-gray, 0.1);

    .header {
      .thumb {
        > .icon {
          @include arrow--up;
        }
      }
    }
  }
}

// Open/opening/closing towards bottom
.component.bottom {
  .header-wrapper {
    border-radius: $border-radius $border-radius 0 0;
  }
}

// Open/opening/closing towards top
.component.top {
  .header-wrapper {
    border-radius: 0 0 $border-radius $border-radius;
  }
}

.component.disabled,
.component.loading {
  .label,
  .wrapper {
    pointer-events: none; // ensure sdx-select can't be opened
  }
}

.component.disabled {
  cursor: not-allowed;

  .label {
    color: $color-input-item-disabled;
  }

  .header-wrapper .header .thumb .icon {
    &::before,
    &::after {
      background-color: $color-input-item-disabled;
    }
  }
}

.component.loading {
  sdx-loading-spinner {
    position: relative;
    right: $baseline;
  }
}

.component.focus {
  sdx-validation-message {
    display: none;
  }
}

.component.dark {
  .label {
    color: $color-white;
  }
}

.component.autocomplete {
  .header:hover {
    cursor: unset; // otherwise cursor "pointer" is shown
  }

  &:not(.loading) {
    .header-wrapper {
      .header {
        padding-right: 0;
      }
    }
  }
}

.component.invalid:not(.focus) {
  .header-wrapper {
    .header {
      .thumb {
        > .icon {
          @include arrow($color-input-invalid-form);
        }
      }

      &:hover {
        .thumb {
          > .icon {
            @include arrow($color-input-invalid-form-hover);
          }
        }
      }
    }
  }
}

.component.sdx--dark-theme {
  .header-wrapper {
    .header {
      .thumb {
        > .icon {
          @include arrow($color-int-blue2-dark-theme);
        }
      }

      &:hover {
        .thumb {
          > .icon {
            @include arrow($color-int-blue2-dark-theme--active);
          }
        }
      }
    }
  }
}

.component.open.sdx--dark-theme,
.component.opening.sdx--dark-theme {
  .header-wrapper {
    box-shadow: none;
  }
}

.component.disabled.sdx--dark-theme {
  .label {
    color: $color-disabled-dark-theme;
  }

  .header-wrapper .header .thumb .icon {
    &::before,
    &::after {
      background: $color-disabled-dark-theme;
    }
  }
}

.component.invalid:not(.focus).sdx--dark-theme {
  .header-wrapper {
    .header {
      .thumb {
        > .icon {
          @include arrow($color-invalid-dark-theme);
        }
      }

      &:hover {
        .thumb {
          > .icon {
            @include arrow($color-invalid-dark-theme--active);
          }
        }
      }
    }
  }
}
